// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"37nVf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _preview = require("@storybook/addon-backgrounds/preview");
parcelHelpers.exportAll(_preview, exports);

},{"@storybook/addon-backgrounds/preview":"gqLCP","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"gqLCP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _preview = require("./dist/preview");
parcelHelpers.exportAll(_preview, exports);

},{"./dist/preview":"9RaOE","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"9RaOE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decorators", ()=>decorators);
parcelHelpers.export(exports, "globals", ()=>globals);
parcelHelpers.export(exports, "parameters", ()=>parameters);
var _previewApi = require("@storybook/preview-api");
var _global = require("@storybook/global");
var _tsDedent = require("ts-dedent");
var _clientLogger = require("@storybook/client-logger");
var PARAM_KEY = "backgrounds";
var { document, window } = (0, _global.global), isReduceMotionEnabled = ()=>window.matchMedia("(prefers-reduced-motion: reduce)").matches, getBackgroundColorByName = (currentSelectedValue, backgrounds = [], defaultName)=>{
    if (currentSelectedValue === "transparent") return "transparent";
    if (backgrounds.find((background)=>background.value === currentSelectedValue)) return currentSelectedValue;
    let defaultBackground = backgrounds.find((background)=>background.name === defaultName);
    if (defaultBackground) return defaultBackground.value;
    if (defaultName) {
        let availableColors = backgrounds.map((background)=>background.name).join(", ");
        (0, _clientLogger.logger).warn((0, _tsDedent.dedent)`
        Backgrounds Addon: could not find the default color "${defaultName}".
        These are the available colors for your story based on your configuration:
        ${availableColors}.
      `);
    }
    return "transparent";
}, clearStyles = (selector)=>{
    (Array.isArray(selector) ? selector : [
        selector
    ]).forEach(clearStyle);
}, clearStyle = (selector)=>{
    let element = document.getElementById(selector);
    element && element.parentElement?.removeChild(element);
}, addGridStyle = (selector, css)=>{
    let existingStyle = document.getElementById(selector);
    if (existingStyle) existingStyle.innerHTML !== css && (existingStyle.innerHTML = css);
    else {
        let style = document.createElement("style");
        style.setAttribute("id", selector), style.innerHTML = css, document.head.appendChild(style);
    }
}, addBackgroundStyle = (selector, css, storyId)=>{
    let existingStyle = document.getElementById(selector);
    if (existingStyle) existingStyle.innerHTML !== css && (existingStyle.innerHTML = css);
    else {
        let style = document.createElement("style");
        style.setAttribute("id", selector), style.innerHTML = css;
        let gridStyleSelector = `addon-backgrounds-grid${storyId ? `-docs-${storyId}` : ""}`, existingGridStyle = document.getElementById(gridStyleSelector);
        existingGridStyle ? existingGridStyle.parentElement?.insertBefore(style, existingGridStyle) : document.head.appendChild(style);
    }
};
var withBackground = (StoryFn, context)=>{
    let { globals: globals2, parameters: parameters2 } = context, globalsBackgroundColor = globals2[PARAM_KEY]?.value, backgroundsConfig = parameters2[PARAM_KEY], selectedBackgroundColor = (0, _previewApi.useMemo)(()=>backgroundsConfig.disable ? "transparent" : getBackgroundColorByName(globalsBackgroundColor, backgroundsConfig.values, backgroundsConfig.default), [
        backgroundsConfig,
        globalsBackgroundColor
    ]), isActive = (0, _previewApi.useMemo)(()=>selectedBackgroundColor && selectedBackgroundColor !== "transparent", [
        selectedBackgroundColor
    ]), selector = context.viewMode === "docs" ? `#anchor--${context.id} .docs-story` : ".sb-show-main", backgroundStyles = (0, _previewApi.useMemo)(()=>{
        let transitionStyle = "transition: background-color 0.3s;";
        return `
      ${selector} {
        background: ${selectedBackgroundColor} !important;
        ${isReduceMotionEnabled() ? "" : transitionStyle}
      }
    `;
    }, [
        selectedBackgroundColor,
        selector
    ]);
    return (0, _previewApi.useEffect)(()=>{
        let selectorId = context.viewMode === "docs" ? `addon-backgrounds-docs-${context.id}` : "addon-backgrounds-color";
        if (!isActive) {
            clearStyles(selectorId);
            return;
        }
        addBackgroundStyle(selectorId, backgroundStyles, context.viewMode === "docs" ? context.id : null);
    }, [
        isActive,
        backgroundStyles,
        context
    ]), StoryFn();
};
var withGrid = (StoryFn, context)=>{
    let { globals: globals2, parameters: parameters2 } = context, gridParameters = parameters2[PARAM_KEY].grid, isActive = globals2[PARAM_KEY]?.grid === !0 && gridParameters.disable !== !0, { cellAmount, cellSize, opacity } = gridParameters, isInDocs = context.viewMode === "docs", defaultOffset = parameters2.layout === void 0 || parameters2.layout === "padded" ? 16 : 0, offsetX = gridParameters.offsetX ?? (isInDocs ? 20 : defaultOffset), offsetY = gridParameters.offsetY ?? (isInDocs ? 20 : defaultOffset), gridStyles = (0, _previewApi.useMemo)(()=>{
        let selector = context.viewMode === "docs" ? `#anchor--${context.id} .docs-story` : ".sb-show-main", backgroundSize = [
            `${cellSize * cellAmount}px ${cellSize * cellAmount}px`,
            `${cellSize * cellAmount}px ${cellSize * cellAmount}px`,
            `${cellSize}px ${cellSize}px`,
            `${cellSize}px ${cellSize}px`
        ].join(", ");
        return `
      ${selector} {
        background-size: ${backgroundSize} !important;
        background-position: ${offsetX}px ${offsetY}px, ${offsetX}px ${offsetY}px, ${offsetX}px ${offsetY}px, ${offsetX}px ${offsetY}px !important;
        background-blend-mode: difference !important;
        background-image: linear-gradient(rgba(130, 130, 130, ${opacity}) 1px, transparent 1px),
         linear-gradient(90deg, rgba(130, 130, 130, ${opacity}) 1px, transparent 1px),
         linear-gradient(rgba(130, 130, 130, ${opacity / 2}) 1px, transparent 1px),
         linear-gradient(90deg, rgba(130, 130, 130, ${opacity / 2}) 1px, transparent 1px) !important;
      }
    `;
    }, [
        cellSize
    ]);
    return (0, _previewApi.useEffect)(()=>{
        let selectorId = context.viewMode === "docs" ? `addon-backgrounds-grid-docs-${context.id}` : "addon-backgrounds-grid";
        if (!isActive) {
            clearStyles(selectorId);
            return;
        }
        addGridStyle(selectorId, gridStyles);
    }, [
        isActive,
        gridStyles,
        context
    ]), StoryFn();
};
var decorators = [
    withGrid,
    withBackground
], parameters = {
    [PARAM_KEY]: {
        grid: {
            cellSize: 20,
            opacity: .5,
            cellAmount: 5
        },
        values: [
            {
                name: "light",
                value: "#F8F8F8"
            },
            {
                name: "dark",
                value: "#333333"
            }
        ]
    }
}, globals = {
    [PARAM_KEY]: null
};

},{"@storybook/preview-api":"uDWyg","@storybook/global":"4g4co","ts-dedent":"lKwH2","@storybook/client-logger":"7OFBO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=preview.c9c30b90.js.map
